// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import CouponFilled from '../_raw/ui/icon_coupon_filled.svg';
import withIconProps from '../withIconProps';

export default withIconProps(CouponFilled);
